<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import { useNotificationStore } from '@/stores/notificationStore';

@Component({})
export default class ExternalApp extends Vue {
  @Prop({ default: '' }) private url!: string;
  private loading = true;
  private notificationStore = useNotificationStore();

  private mounted() {
    if (this.$refs?.frame) {
      (this.$refs.frame as HTMLElement).addEventListener('load', this.notLoading)
    }
    window.addEventListener("message", this.handleMessage);
  }

  private beforeUnmount() {
    window.removeEventListener("message", this.handleMessage);
    if (this.$refs?.frame) {
      (this.$refs.frame as HTMLElement).removeEventListener('load', this.notLoading);
    }
  }

  private notLoading() {
    this.loading = false;
  }

  private handleMessage(event: MessageEvent) {
    if (event.origin !== new URL(this.url || '').origin) {
      return;
    }
    if (!event.data || !event.data.length) {
      console.debug('Received unknown event message from iframe with origin:', event.origin, ' | data: NONE');
      return;
    }
    let eventData;
    try {
      eventData = JSON.parse(event.data);
    } catch (e) {
      console.debug('Error parsing event data from iframe with origin:', event.origin, ' | error: ', e, ' | data: ', event.data);
      return;
    }
    if (eventData.type === 'refreshToken') {
      console.debug('Received refreshToken event message from iframe with origin:', event.origin);
      this.$router.go(0);
      return;
    }
    console.debug('Received unknown event message from iframe with origin:', event.origin, ' | data: ', eventData);
  }

  private get appUrl(): string | undefined {
    return this.url;
  }

}
</script>

<template>
  <div class="fill-height embed-container overflow-x-hidden">
    <iframe v-show="!loading" ref="frame" class="embed-container" width="100%" height="100%" style="border: none" :src="appUrl" allowUserMedia :allow="`camera`"></iframe>
  </div>
</template>

<style scoped>

</style>
